export const account = {
    status_data: {},
    test: {},
    detail_form: {
        user_name:'',
        name:'',
        personal_email: '',
        company_email:'',
    },
    account_form: {
        old_password:'',
        password: '',
        repeat_password: ''
    },
    is_button_disabled: false,
    is_loading_register: false,
    dialog: {
        is_dialog_open: false,
        dialog_title: '',
        dialog_title_class:''
    },

}


// WEBPACK FOOTER //
// ./src/reducers/account/account.state.js